export enum Locale {
  EN = 'en',
  SV = 'sv',
  FI = 'fi',
}
